<div class="text-normal bg-card shadow-md rounded-lg p-6">
    <h2 class="text-2xl font-bold mb-4">{{label | translate}}</h2>
    <div class="flex items-center">
        <input
                type="text"
                [value]="link"
                readonly
                class="flex-1 p-2 border  bg-card-hover border-none rounded focus:outline-none ring-0"
        />

        <button
                (click)="copyLink()"
                [ngClass]="{
                    'bg-primary hover:bg-primary-hover': !copySuccess,
                    'bg-green hover:bg-green-hover': copySuccess
                }"
                class="px-4 py-2 rounded-r text-white  transition-colors duration-200"
        >
            {{(copySuccess  ? 'copied': 'copy') | translate}}
        </button>
    </div>
</div>
